import { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { blogpostsApi } from 'api/client';
import { SITE_NAME } from 'brand';
import Container from 'components/common/Container/Container';
import Interactions from 'components/Interactions';
import styles from './Blog.module.css';

export default function BlogpostDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [blogpost, setBlogpost] = useState(null);
  const [userVote, setUserVote] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBlogpost = async () => {
      try {
        const { blogpost: data, userVote: uv } = await blogpostsApi.get(id);
        setBlogpost(data);
        setUserVote(uv || 0);
        document.title = `${data.title} · ${SITE_NAME}`;
      } catch (err) {
        if (err.status === 404) {
          navigate('/not-found', { replace: true });
        } else {
          setError('Failed to load the blogpost.');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchBlogpost();
  }, [id, navigate]);

  if (loading) return <Container className={styles.detailContainer} role="status">Loading blogpost...</Container>;
  if (error) return <Container className={styles.detailContainer} style={{ color: 'var(--error)' }}>{error}</Container>;
  if (!blogpost) return null;

  return (
    <Container className={styles.detailContainer} style={{ display: 'block' }}>
      <Link to="/blog" className={styles.backBtn}>
        <span aria-hidden="true">← </span>Back to Blogposts
      </Link>

      {blogpost.cover_image && (
        <img src={blogpost.cover_image} alt={blogpost.cover_image_alt || ""} className={styles.detailImage} />
      )}

      <header className={styles.detailHeader}>
        <h3 className={styles.detailTitle}>{blogpost.title}</h3>
        <div className={styles.detailMeta}>
          <span className={styles.author}>By {blogpost.author}</span>
          <span className={styles.date}>{new Date(blogpost.published_date).toLocaleDateString()}</span>
        </div>
      </header>

      {/* Renders the HTML generated by React Quill */}
      <div 
        className={styles.contentHtml} 
        dangerouslySetInnerHTML={{ __html: blogpost.content_html }} 
      />

      <Interactions 
        id={blogpost.id} 
        type="blogpost" 
        api={blogpostsApi} 
        initialVotes={blogpost.votes || 0} 
        initialUserVote={userVote} 
      />
    </Container>
  );
}

